export const ACCOUNT_TYPES_EVENT = "enaia:mobile:account-types:v1"
export const ACCOUNT_TYPES = Object.freeze([
  "clients",
  "prospects",
  "inactive",
  "formerClients",
])

const STAGES = Object.freeze({
  clients: ["client"],
  prospects: [
    "researching",
    "active_pursuit",
    "intro_meeting",
    "high_priority",
  ],
  inactive: ["inactive"],
  formerClients: ["former_client"],
})

export function accountTypeSelection(value) {
  if (
    !Array.isArray(value) ||
    value.length > ACCOUNT_TYPES.length ||
    value.some((type) => !ACCOUNT_TYPES.includes(type)) ||
    new Set(value).size !== value.length
  )
    return null
  return [...value]
}

export function accountTypeFilterOptions(selection) {
  const selected = accountTypeSelection(selection)
  // An ordinary browser, or an older native build, retains the existing grid.
  const active = selected !== null && selected.length !== ACCOUNT_TYPES.length
  const stages = new Set(
    (selected ?? ACCOUNT_TYPES).flatMap((type) => STAGES[type]),
  )
  return {
    isExternalFilterPresent: () => active,
    doesExternalFilterPass: ({ data }) =>
      !active || stages.has(data?.account_stage),
  }
}
